// extracted by mini-css-extract-plugin
export default {"Menu":"bgw_a bhl_h","Menu__offsetParent":"bgw_b bhl_bj","Menu__trigger--shadowed":"bgw_c"};